import api from './axios';

export const dashboardAPI = {
  /**
   * GET /api/admin/dashboard
   * Returns platform-wide statistics for the admin dashboard.
   */
  getStats: () => api.get('/admin/dashboard'),
};
